// Player profile client - talks to /api/profile and caches locally.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function normalizeTag(tag) {
  return (tag || '').trim().toUpperCase().slice(0, 16);
}

export async function fetchProfile(tag) {
  const t = normalizeTag(tag);
  if (!t) return null;
  try {
    const r = await axios.get(`${API}/profile/${encodeURIComponent(t)}`);
    return r.data;
  } catch (e) {
    return null;
  }
}

export async function patchProfile(tag, update) {
  const t = normalizeTag(tag);
  if (!t) return null;
  try {
    const r = await axios.patch(`${API}/profile/${encodeURIComponent(t)}`, update);
    return r.data;
  } catch (e) {
    return null;
  }
}

export async function fetchRivals(tag) {
  const t = normalizeTag(tag);
  if (!t) return [];
  try {
    const r = await axios.get(`${API}/profile/${encodeURIComponent(t)}/rivals`);
    return r.data.rivals || [];
  } catch (e) {
    return [];
  }
}

export async function fetchSeedGhosts(seed) {
  try {
    const r = await axios.get(`${API}/leaderboard/seed/${encodeURIComponent(seed)}`);
    return r.data || [];
  } catch (e) {
    return [];
  }
}

export async function fetchCurse(runCode) {
  try {
    const r = await axios.get(`${API}/curses/${encodeURIComponent(runCode)}`);
    return r.data;
  } catch (e) {
    return null;
  }
}

// v3.10 STACKED CURSES: fetch the entire stack of curses planted on a run code.
export async function fetchCurseStack(runCode) {
  try {
    const r = await axios.get(`${API}/curses/${encodeURIComponent(runCode)}/stack`);
    return r.data || { curses: [], count: 0 };
  } catch (e) {
    return { curses: [], count: 0 };
  }
}

export async function createCurse(payload) {
  try {
    const r = await axios.post(`${API}/curses`, payload);
    return r.data;
  } catch (e) {
    return null;
  }
}

// ---- Week key helper ----
export function currentWeekKey() {
  const d = new Date();
  const target = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  const dayNum = (target.getUTCDay() + 6) % 7;
  target.setUTCDate(target.getUTCDate() - dayNum + 3);
  const firstThursday = new Date(Date.UTC(target.getUTCFullYear(), 0, 4));
  const week = 1 + Math.round(((target - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
  return `${target.getUTCFullYear()}-W${String(week).padStart(2, '0')}`;
}

export function seedForWeekly() {
  const k = currentWeekKey();
  let h = 5381;
  for (let i = 0; i < k.length; i++) h = ((h << 5) + h + k.charCodeAt(i)) & 0xffffffff;
  const abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let s = 'W';
  let n = Math.abs(h);
  for (let i = 0; i < 5; i++) { s += abc[n % abc.length]; n = Math.floor(n / abc.length); }
  return s;
}
